export enum AutoResume {
  disabled,
  idle,
  notIdle
}
